import { Stack, Typography, TypographyProps } from '@mui/material'
import { CampaignPostFooter } from '../CampaignPostFooter'
import { UnsetAlert } from './UnsetAlert'

type CampaignInfoBlockProps = {
  label: string
  icon?: React.ReactNode
  children: React.ReactNode
  isEmpty?: boolean
  labelTypographyProps?: TypographyProps
}

export const CampaignInfoBlock: React.FC<CampaignInfoBlockProps> = ({
  label,
  children,
  isEmpty = false,
  labelTypographyProps,
}) => {
  return (
    <Stack gap={2} sx={{ overflowWrap: 'anywhere', wordBreak: 'normal' }}>
      <Typography fontWeight="bold" variant="bodyL" {...labelTypographyProps}>
        {label}
      </Typography>
      {isEmpty ? (
        <UnsetAlert sx={{ mt: 0.5 }}>
          <Typography variant="body2">未設定</Typography>
        </UnsetAlert>
      ) : (
        <CampaignPostFooter>{children}</CampaignPostFooter>
      )}
    </Stack>
  )
}
